import React from "react";
import Blocks from "../Components/blocks";
import Navbar from "../Components/Navbar";

const Homepage = () => {
  return (
    <>
      <Navbar />

      <div className="flex">
        <div className="w-[80vw] mx-auto">
          <Blocks />
        </div>
      </div>
    </>
  );
};

export default Homepage;
